import { HTML5Backend } from 'react-dnd-html5-backend';
import { ReactNode, Component, ErrorInfo } from 'react';
import { DndProvider as ReactDndProvider } from 'react-dnd';

interface DndProviderProps {
  children: ReactNode;
}

interface ErrorBoundaryState {
  hasError: boolean;
  error?: Error;
}

class DndErrorBoundary extends Component<{ children: ReactNode }, ErrorBoundaryState> {
  constructor(props: { children: ReactNode }) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error: Error): ErrorBoundaryState {
    // 如果是react-dnd的错误，记录但不阻止渲染
    if (error.message.includes('Expected an existing target')) {
      return { hasError: false };
    }
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    // 记录错误信息
    if (!error.message.includes('Expected an existing target')) {
      // 记录非预期的拖拽错误
    }
  }

  render() {
    const { hasError } = this.state;
    const { children } = this.props;
    
    if (hasError) {
      return (
        <div style={{ padding: '20px', textAlign: 'center' }}>
          <h3>组件出现错误</h3>
          <p>请刷新页面重试</p>
        </div>
      );
    }

    return children;
  }
}

export default function DndProvider({ children }: DndProviderProps) {
  return (
    <DndErrorBoundary>
      <ReactDndProvider backend={HTML5Backend}>
        {children}
      </ReactDndProvider>
    </DndErrorBoundary>
  );
}